<template>
  <div class="main">
    <el-row class="row animated fadeIn">
      <el-col class="r-el" :sm="6">
        <div class="r-box">
          <h5><a href="javascript:;"><span><i class="iconfont">&#xe6fb;</i>產品</span></a></h5>
          <div class="r-content">
            <router-link to="products/new_daily_van">
              <div class="r-img"><img src="../../images/product.jpg" title="IVECO宣佈任命新的品牌總裁"/></div>
              <!-- <h6>產品說明</h6> -->
              <div class="p">
                <p>符合歐盟6D排放標準的全新DAILY貨VAN王務求助你的業務可持續發展及符合經濟效益。</p>
                <div class="btn-wrap">
                  <router-link to="products/new_daily_van" class="btn">更多資訊<i class="iconfont">&#xe610;</i></router-link>
                  <!-- <router-link to="/contact" class="btn">更多資訊<i class="iconfont">&#xe610;</i></router-link> -->
                  </div>
              </div>
            </router-link>
          </div>
        </div>
      </el-col>
      <el-col class="r-el" :sm="6">
        <div class="r-box">
          <h5><a href="javascript:;"><span><i class="iconfont">&#xe737;</i>最新資訊</span></a></h5>
          <div class="r-content">
            <router-link :to="'/news/detail/' + dataNews.id" >
              <div class="r-img">
                <!-- <el-image :lazy="true"  class="table-imgpath" :src="urlNews + dataNews.mainImage" :title="dataNews.title">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>                                              
                  </div>
                </el-image> -->
                <img :src="urlNews + dataNews.mainImage" :title="dataNews.title"/>
              </div>
              <h6>{{dataNews.title}}</h6>
              <div class="p">
                <p>{{dataNews.summary}} </p>
              </div>
            </router-link>
          </div>
        </div>
      </el-col>
      <el-col class="r-el" :sm="6">
        <div class="r-box">
          <h5><a href="javascript:;"><span><i class="iconfont">&#xe60b;</i>售後服務</span></a></h5>
          <div class="r-content">
            <a href="javascript:;">
              <div class="r-img"><img src="../../images/repair.jpg" title="IVECO宣佈任命新的品牌總裁"/></div>
              <!-- <h6>IVECO宣佈任命新的品牌總裁</h6> -->
              <div class="p">
                <p>IVECO 香港及澳門全新獨家總代理STAR AUTO為錦龍汽車集團旗下分公司，為客戶提供2020 歐盟6D 車型一站式銷售服務及方案，及提供最穩健的售後及保修服務。<span class="ph">歡迎查詢：+852 2119 4809 </span></p>
              </div>
            </a>
          </div>
        </div>
      </el-col>
      <el-col class="r-el" :sm="6">
        <div class="r-box">
          <h5><a href="javascript:;"><span><i class="iconfont">&#xe66e;</i>聯繫我們</span></a></h5>
          <div class="r-content">
            <router-link to="/contact" href="javascript:;">
              <div class="r-img"><img src="../../images/drive.jpg" title="IVECO宣佈任命新的品牌總裁"/></div>
              <!-- <h6>IVECO宣佈任命新的品牌總裁</h6> -->
              <div class="p">
                <p>IVECO歐意汽車，為全球擁有最齊全商用車系列的製造商之一，品牌不斷在商用車的研發、製造、營銷和售後服務上，引領全球新標準。<span class="ph">歡迎查詢：+852 2119 4809 </span></p>
              </div>
            </router-link>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Element from 'element-ui';  //Element插件
import { reqNewsList } from '../../untils/api.js'

export default {
  name: 'Main',
  data () {
    return {
      urlNews: this.$store.state.baseURL + '/iveco/news/getNewsImge?fileName=',
      dataNews: {}, //返回的结果集合
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  }, 
  created () {
  },
  mounted() {
    let dataNews = {
      currentPage: this.currentPage,
      pageSize: this.pageSize
    }
    reqNewsList(dataNews).then(res => {
      if (res.code == 200) {
        let data = res.data.data
        let dataNewsTable = []
        this.total = data.total
        data.list.forEach(e => {
          if(e.status == 1){
            dataNewsTable.push(e)
          }
        })
        if (dataNewsTable.length == '' || dataNewsTable.length == 0) {
          let d = {
            currentPage: this.currentPage,
            pageSize: this.total
          }
          this.queryNews(d)
        } else {
          this.dataNews = dataNewsTable[0]
        }
      }
    })
  },
  methods: {
    queryNews(d) {
      reqNewsList(d).then(res => {
        if (res.code == 200) {
          let data = res.data.data
          let dataNewsTable = []
          data.list.forEach(e => {
            if(e.status == 1){
              dataNewsTable.push(e)
            }
          })
          this.dataNews = dataNewsTable[0]
        }
        console.log('this.dataNews', this.dataNews)
      })
    }
  },
  components: {
  }
}
</script>

<!--[if lt IE 9]>
  <style>
    .row {
      .r-el {
        .r-box {
          .r-content {
            a {
              .r-img {
                img {
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }
  </style>
<![endif]-->

<style lang="stylus" ref="stylesheet/stylus" scoped>

  .ph {
    width: 100%;
    display:inline-block;
    margin-top: 6px;
    font-weight: 600;
  }
  .row {
    margin-bottom: 0;
    overflow: hidden;
    .r-el {
      overflow: hidden;
      .r-box {
        background: #fff;
        padding: 10px;
        position: relative;
        margin: 0 0 20px 0;
        min-height: 35px;
        h5 {
          background: #000;
          color: #fff;
          font-family: "GillSans", "Microsoft YaHei", Arial, sans-serif;
          text-transform: uppercase;
          font-size: 13px;
          position: relative;
          margin: 0;
          padding: 6px 0;
          a {
            color: #fff;
            text-decoration: none;
            display: block;
            overflow: hidden
            i {
              display: inline-block;
              font-size: 16px;    
              padding-right: 6px;
              padding-left: 5px;
            }
          }
          span {
            display: inline-block;
          }
        }
        .r-content {
          // position: relative;
          a {
            height: 100%;
            color: #333;
            display: block;
            text-decoration: none;
            position: relative; 
            .r-img {
              height: auto;
              margin-bottom: 10px;
              .table-imgpath {
                width: 100%;
                .image-slot {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  height: 80px;
                  background: #f5f7fa;
                  color: #909399;
                  font-size: 30px;
                }
              }
              img {
                min-width: 100%;
                max-width: 100%;
                height: 100% \9; 
                *height: 100%; 
                _height: 100%; 
              }
            }
            h6 {
              font-weight: bold;
              margin: 0 0 10px 0;
            }
            .p {
              margin: 0 0 9px;
              .btn-wrap {
                text-align: right;
                padding-top: 6px;
                .btn {
                  display: inline-block;
                  text-transform: uppercase;
                  text-decoration: none;
                  font-family: "GillSans", "Microsoft YaHei", Arial, sans-serif;
                  position: relative;
                  border: none;
                  padding: 8px 22px 8px 12px;
                  transition: opacity 200ms;    
                  color: #fff;
                  background-color: #000;
                  border-color: #000;
                  i {
                    font-size: 12px;
                    width: 0;
                    height: 0;
                    position: absolute;
                    top: 6px;
                    right: 18px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* IE10+ CSS styles go here */
    .row {
      .r-el {
        .r-box {
          .r-content {
            a {
              .r-img {
                img {
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }
  }
  @media (min-width: 768px) {
    .row {
      padding-bottom: 20px;
      .r-el {
        .r-box {
          height: 384px;
          margin: 0;
          h5 {
            a {
              i {
                padding-left: 8px;
              }
            }
          }
          .r-content {
            a {
              .r-img {
                height : 99px;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                justify-content: center;
              }
              .p {
                height: 164px;
                overflow-y: auto;
                .btn-wrap {
                  .btn {
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 992px) {
    .row {
      .r-el {
        .r-box {
          height: 325px;
          h5 {
            position: absolute;
            top: 15px;
            left: -7px;
            z-index: 1000;
            padding: 0;
            &::before {
              content: '';
              width: 0;
              height: 0;
              border-style: solid;
              border-width: 0 0 5px 7px;
              border-color: transparent transparent #666 transparent;
              position: absolute;
              top: -5px;
              left: 0;
            }
            a {
              color: #fff;
              text-decoration: none;
              display: block;
              overflow: hidden;
              span {
                vertical-align: middle;
                padding: 5px 10px 5px 0;
                margin-left: 0;
              }
            }
          }
          .r-content {
            a {
              .r-img {
                height: 141px;
              }
              .p {
                height: 126px;
                overflow-y: auto;
                .btn-wrap {
                  .btn {
                    padding: 6px 22px 6px 12px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 1200px) {
    
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/Main.vue